import * as React from 'react';
import { getUtcUsFormatDate } from 'modules/utils/time';
import { TextWrapper as DescriptionText } from 'components/member/MemberListColumns';
import { TableCell } from 'types/common/table';
import { Coupon } from 'types/member';
import { couponReasonLabel, couponStatusLabel, CouponType } from 'constants/member/connect';

export default [
  { align: 'center', name: 'Coupon ID', key: 'couponId', render: rowData => rowData.couponId },
  {
    align: 'center',
    name: 'Description',
    key: 'couponDesc',
    render: rowData => <DescriptionText>{rowData.couponDesc}</DescriptionText>,
  },
  {
    align: 'center',
    name: 'Price/Rate',
    key: 'amount',
    render: rowData =>
      rowData.couponType === CouponType.PRICE ? `$${rowData.amount}` : `${rowData.amount}%`,
  },
  { align: 'center', name: 'Context', key: 'context', render: rowData => couponReasonLabel[rowData.context] },
  {
    align: 'center',
    name: 'Status',
    key: 'status',
    render: rowData => couponStatusLabel[rowData.status] ?? 'Error',
  },
  {
    align: 'center',
    name: 'Created Date',
    key: 'createdDate',
    render: rowData => getUtcUsFormatDate(rowData.createdDate),
  },
  {
    align: 'center',
    name: 'Expiration Date',
    key: 'expirationDate',
    render: rowData => getUtcUsFormatDate(rowData.expirationDate),
  },
  { align: 'center', name: 'Created By', key: 'createdBy', render: rowData => rowData.createdBy },
] as TableCell<Coupon>[];
